module.exports = __webpack_public_path__ + "img/workshops_4.d3a5b8ac.png";